import React, { useContext, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getTermMeals } from "../../../queries";
import { OrderContext } from "../../../contexts/order_context";
import { useFormContext } from "react-hook-form";
import { useWatch } from "react-hook-form";

const MealsConfig = ({
  number,
  selectedTermId,
  selectedRoomConfigId,
  isExtra,
}) => {
  const { termId, mealTypeId } = useContext(OrderContext);
  const refName = isExtra ? `extra_meals.${number}.id` : `meals.${number}.id`;
  const mealValue = useWatch({ name: refName });

  // Strava zvolená ve filtru vyhledávání - jen pro hlavní pobyt, cena ve výpisu
  // termínů příplatek za prodloužený pobyt nezahrnuje.
  const findMealFromFilter = (meals) =>
    !isExtra && mealTypeId
      ? meals?.find((meal) => String(meal.meal_type_id) === String(mealTypeId))
      : null;

  const { register, setValue, getValues } = useFormContext({
    defaultValues: {
      [refName]: mealValue,
    }
  });

  const termMealsQuery = useQuery(
    [
      "meals",
      {
        termId: selectedTermId || termId,
        roomConfig: selectedRoomConfigId,
      },
    ],
    () =>
      getTermMeals({
        termId: selectedTermId || termId,
        roomConfig: selectedRoomConfigId,
      }),
    {
      onSuccess: (data) => {
        // volba klienta má přednost, dokud je pro danou konfiguraci pokoje v nabídce
        const currentId = getValues(refName);
        if (data.some((meal) => String(meal.id) === String(currentId))) return;

        const preselected =
          findMealFromFilter(data) || data.find((meal) => meal.required);
        if (!preselected) return;

        setValue(refName, String(preselected.id));
      },
    }
  );

  const mealFromFilter = findMealFromFilter(termMealsQuery.data);

  useEffect(() => {
    // if (termMealsQuery.isFetching || termMealsQuery.isLoading) return;

    termMealsQuery.refetch();
  }, [selectedRoomConfigId]);

  return (
    <div className="rooms-var__item">
      <h4>{I18n.t(`js.order.meals.room${number == "one" ? 1 : 2}`)}</h4>
      {termMealsQuery.data?.map((meal) => {
        return (
          <div key={`meal-${number}-${meal.id}`} className="form-check">
            <input
              className="form-check-input meal_radio"
              type="radio"
              name={refName}
              {...register(refName)}
              value={meal.id}
              defaultChecked={
                mealValue
                  ? meal.id == mealValue
                  : mealFromFilter
                  ? meal.id === mealFromFilter.id
                  : meal.required
              }
              id={`${refName}.${meal.id}`}
            />
            <label
              className="form-check-label"
              htmlFor={`${refName}.${meal.id}`}
            >
              <span className="label-title">{meal.name}</span>
              <span className="label-price">
                {meal.required ? (
                  <em>{I18n.t("js.order.included")}</em>
                ) : (
                  <strong>{`${meal.price} / ${I18n.t(
                    "js.order.room"
                  )}`}</strong>
                )}
              </span>
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default MealsConfig;
